<template>
  <b-container fluid class="no-sided-margin">
    <b-row>
      <b-col class="no-sided-padding">
        <b-tabs ref="warnings-tab" v-model="tab" fill pills card>
          <b-tab title="Elenco">
            <div style="padding-top: 10px">
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                Visualizza le adesioni rifiutate da Conad, indicando la motivazione, e consente il reinvio.
              </b-alert>
            </div>
            <b-row>
              <b-col cols="2">
                <b-card header-bg-variant="light">
                  <template #header>
                    <div class="custom-card-header">
                      <strong>
                        <b-icon-funnel></b-icon-funnel>
                        Filtri</strong>
                    </div>
                  </template>
                  <b-card-body style="padding: 0.5rem">
                    <b-form @submit="filterWarnings">
                      <b-form-group label="Stato">
                        <b-form-radio-group v-model="statusFilter" buttons fluid>
                          <b-form-radio button-variant="outline-primary" value="NEW">Nuova</b-form-radio>
                          <b-form-radio button-variant="outline-primary" value="WIP">In Lavorazione</b-form-radio>
                          <b-form-radio button-variant="outline-primary" value="DONE">Risolta</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>
                      <b-button type="submit" variant="primary" block id="search">
                        <b-icon-search/>&nbsp;Cerca
                      </b-button>
                    </b-form>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="10">
                <b-card header-bg-variant="light">
                  <template #header>
                    <div style="height: 1.5rem">
                      <div v-show="searched" class="float-right">
                        <h6 class="filters-list-head">
                          Filtri applicati:
                          <b-badge class="filter-badge" v-show="statusFilter" @click="removeFilter()" variant="info" pill tag="button">Stato: <i>{{ translateStatus(confirmedStatusFilter) }}</i>&nbsp;<b-icon-x-circle-fill
                            variant="light"/>
                          </b-badge>
                        </h6>
                      </div>
                    </div>
                    <div style="height: 1.5rem">
                      <span><strong><b-icon-card-checklist/>&nbsp;Segnalazioni trovate</strong></span>
                    </div>
                  </template>
                  <b-card-body>
                    <b-table sticky-header="71vh" :no-border-collapse="true" responsive :fields="fields" :items="warnings">
                      <template #cell(shop)="data">
                        <span class="cap-smalled">{{ formatShop(data.item.shopCode) }}</span>
                      </template>
                      <template #cell(signedAt)="data">
                        {{ formatDateTime(data.item.signedAt) }}
                      </template>
                      <template #cell(fullname)="data">
                        {{ data.item.lastName }}
                        {{ data.item.firstName }}
                        <span class="cap-smalled"><br>{{ data.item.barcode }}</span>
                      </template>
                      <template #cell(dataEntryMode)="data">
                        <div v-if="dataEntryModeShowPill(data.item.dataEntryMode)" :class="dataEntryModeStyle(data.item.dataEntryMode)">
                          {{ dataEntryMode(data.item.dataEntryMode) }}
                        </div>
                        <br>
                        <div :class="procedureStyle(data.item.procedureChoice)">
                          {{ procedureChoice(data.item.procedureChoice) }}
                        </div>
                      </template>
                      <template #cell(message)="data">
                        <div v-b-popover.hover.top="popoverConfig(data.item.type, data.item.errorMessage)" title="Messaggio" class="text-truncate" style="max-width: 200px">{{ translateType(data.item.type, data.item.errorMessage) }}</div>
                      </template>
                      <template #cell(note)="data">
                        <div v-b-popover.hover.top="data.item.note" title="Nota" class="text-truncate" style="max-width: 200px"> {{ data.item.note || 'Nessuna nota' }}</div>
                      </template>
                      <template #cell(actions)="data">
                        <b-button-toolbar>
                          <b-button-group class="mr-2">
                            <b-button size="sm" title="Modifica le note" v-b-tooltip.hover variant="success" ref="note" v-b-modal.noteModal @click="editNote(data.item)">
                              <b-iconstack>
                                <b-icon stacked icon="file"></b-icon>
                                <b-icon stacked icon="pencil-fill" scale="0.8" shift-h="5" shift-v="1"></b-icon>
                              </b-iconstack>
                            </b-button>
                            <b-button size="sm" title="Scarica adesione" v-b-tooltip.hover variant="secondary" ref="download"
                                      :href="`/api/memberships/${data.item.serviceId}/signed_agreement`" target="_blank">
                              <b-icon icon="download" aria-hidden="true"></b-icon>
                            </b-button>
                            <b-button size="sm" @click="membershipDetails(data.item.serviceId)" title="Dettaglio" v-b-tooltip.hover variant="info">
                              <b-icon icon="eye-fill" aria-hidden="true"></b-icon>
                            </b-button>
                          </b-button-group>
                        </b-button-toolbar>
                      </template>
                      <template #cell(state)="data">
                        <b-dropdown size="sm" :disabled="isSent(data.item.status)" id="status-dropdown" dropright :text="translateStatus(data.item.status)" :variant="statusVariant(data.item.status)" class="m-2">
                          <b-dropdown-item @click="patchWarningStatus(data.item.id, 'NEW')">NUOVA</b-dropdown-item>
                          <b-dropdown-item @click="patchWarningStatus(data.item.id, 'WIP')">IN LAVORAZIONE</b-dropdown-item>
                          <b-dropdown-item @click="patchWarningStatus(data.item.id, 'DONE')">RISOLTA</b-dropdown-item>
                        </b-dropdown>
                      </template>
                    </b-table>
                  </b-card-body>
                </b-card>
                <b-pagination
                  v-if="warningsAmount>100"
                  align="right"
                  v-model="currentPage"
                  @change="findWarnings"
                  :per-page="pageSize"
                  :total-rows="warningsAmount"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Dettaglio Adesione">
            <Details :modifiable="showEditMembershipFeature"/>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <ModalNote :note="currentWarning.note" :warning-id="currentWarning.id" :note-saving="noteSaving" event-name="warning-note-edited" @warning-note-edited="saveNote"/>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></p>
    </div>
  </b-container>
</template>

<script>
import WarningsApi from '../api/WarningsApi'
import moment from 'moment'
import Translate from '@/Translate'
import Details from '@/components/memberships/Details'
import Style from '@/Style'
import eventBus from '@/EventBus'
import ModalNote from "@/components/ModalNote";
import ShopsApi from "@/api/ShopsApi";

export default {
  name: 'Warnings',
  components: { ModalNote, Details },
  props: ['session'],
  mounted () {
    ShopsApi.all().then(result => this.shops = result)
    eventBus.$on("show-alert", () => this.showAlert = true)
    this.findWarnings(this.currentPage)
  },
  data: () => ({
    showAlert: false,
    fields: [
      { key: 'shop', label: 'Negozio' },
      { key: 'dataEntryMode', label: 'Provenienza' },
      { key: 'signedAt', label: 'Data firma' },
      { key: 'fullName', label: 'Nominativo', class: 'text-center' },
      { key: 'message', label: 'Messaggio' },
      { key: 'note', label: 'Note' },
      { key: 'state', label: 'Stato' },
      { key: 'actions', label: '' }
    ],
    currentWarning: {
      id: null,
      note: null
    },
    warnings: [],
    membership: null,
    tab: 0,
    noteSaving: false,
    statusFilter: null,
    confirmedStatusFilter: null,
    searched: false,
    shops: null,
    warningsAmount: 1,
    currentPage: 1,
    pageSize: 100,
  }),
  computed: {
    showEditMembershipFeature () {  return this.session.tokenParsed.realm_access.roles.includes('membership_alteration') },
  },
  methods: {
    isSent(status) {
      return status === 'SENT'
    },
    editNote (warning) {
      this.currentWarning.id = warning.id
      this.currentWarning.note = warning.note
    },
    saveNote (data) {
      this.noteSaving = true
      WarningsApi.setNote(data.warningId, data.note)
        .then(this.findWarnings)
        .finally(() => this.noteSaving = false)
    },
    findWarnings (page) {
      const pageNum = page || this.currentPage || 1;
      let promise = this.statusFilter != null
        ? WarningsApi.findByStatus(this.statusFilter , pageNum, this.pageSize)
        : WarningsApi.findAll(pageNum, this.pageSize)

      promise.then(result => {
        this.warnings = result.warnings
        this.warningsAmount = result.pageCount * this.pageSize
      })
    },
    filterWarnings (event) {
      if (event) event.preventDefault()

      this.searched = true
      this.confirmedStatusFilter = this.statusFilter
      this.currentPage = 1
      this.findWarnings(this.currentPage)
    },
    patchWarningStatus (warningId, status) {
      WarningsApi.patch(warningId, { status })
        .then(() => {
          this.warnings.find(item => item.id === warningId).status = status
          eventBus.$emit('received-new-warnings', this.warnings.filter(warning => warning.status === 'NEW').length)
        })
    },
    membershipDetails (id) {
      eventBus.$emit("membership-detail", id)

      this.tab = 1
    },
    removeFilter () {
      this.statusFilter = null
      this.confirmedStatusFilter = null
      this.searched = false
      this.findWarnings()
    },
    dataEntryModeStyle (dataEntryMode) {
      return Style.dataEntryModeStyle(dataEntryMode)
    },
    procedureStyle (procedureChoice) {
      return Style.procedureStyle(procedureChoice)
    },
    dataEntryMode (dataEntryMode) {
      return Translate.dataEntryMode(dataEntryMode)
    },
    procedureChoice (procedureChoice) {
      return Translate.procedureChoice(procedureChoice)
    },
    dataEntryModeShowPill(dataEntryMode){
      return Style.showDataEntryModePill(dataEntryMode)
    },
    formatShop(shopCode) {
      if (!this.shops) return shopCode;
      const shop = this.shops.find(item => item.code === shopCode)
      if (shop) {
        return `${shopCode} - ${shop.name}`
      } else {
        return `${shopCode} - Negozio non trovato`
      }
    },
    formatDateTime (date) {
      return date
        ? moment.utc(date).local().format('DD/MM/YYYY HH:mm')
        : ''
    },
    popoverConfig(type, messages) {
      return {
        html: true,
        content: () => {
          return this.translateType(type, messages, true)
        }
      }
    },
    translateType(type, messages, popOver = false) {
      switch (type) {
        case 'DEMATERIALIZED_REISSUE':
          return "Sostituzione fatta su una tessera Dematerializzata. Per poter procedere alla sostituzione, prima il cliente deve disattivare la tessera sull'applicazione Conad."
        case 'DEMATERIALIZED_UPDATE':
          return "Aggiornamento fatto su una tessera Dematerializzata. L'aggiornamento di questa può essere fatta solo dal cliente tramite l'applicazione Conad."
        case 'WRONG_BARCODE':
          return  "Inserimento di un tessera con il codice errato. Contattate il cliente per richiedere il codice tessera corretto, successivamente contattare CherryChain."
        case 'WRONG_INPUT':
          return  this.getWrongInput(messages, popOver)
        default:
          return "Errore generico"
      }
    },
    getWrongInput(messages, popOver) {
      let message = ""
      let splitter = " "
      if(popOver === true) {splitter = "<br>"}
      messages.forEach(item => {
        let translatedWords = item.split(" ").map(word => this.translateToItalian(word));
        let translatedItem = translatedWords.join(" ");

        message += translatedItem + splitter;
      })
      return message
    },
  translateToItalian(word){
  switch (word){
    case 'Surname':
      return "Cognome"
    case 'Name':
      return "Nome"
    case 'Sex':
      return "Sesso"
    case 'Adress':
      return "Indirizzo"
    case 'AdressNumber':
      return "Numero civico"
    case 'PostCode':
      return "CAP"
    case 'BirthDate':
      return "Data di nascita"
    case 'ResidenceCode':
      return "Codice catastale comune di residenza"
    case 'Residence':
      return "Comune di residenza"
    case 'NationCode':
      return "Codice nazione di residenza"
    case 'Nation':
      return "Nazione di residenza"
    case 'ProvinceCode':
      return "Codice provincia di residenza"
    case 'Province':
      return "Provincia di residenza"
    case 'BirthPlaceCode':
      return "Codice catastale luogo di nascita"
    case 'BirthPlace':
      return "Luogo di nascita"

    default:
      return word
  }
  },
    translateStatus (status) {
      switch (status) {
        case 'NEW':
          return 'NUOVA'
        case 'WIP':
          return 'IN LAVORAZIONE'
        case 'DONE':
        case 'SENT':
          return 'RISOLTA'
      }
    },
    statusVariant (status) {
      switch (status) {
        case 'NEW':
          return 'primary'
        case 'WIP':
          return 'warning'
        case 'DONE':
        case 'SENT':
          return 'success'
      }
    }
  }
}
</script>

<style>
#status-dropdown > .dropdown-menu.show {
  background-color: white;
  background-image: unset;
}

.popover {
  max-width: 500px !important;
}
</style>
